export enum NotificationTypes {
  DANGER = 'danger',
  INFO = 'info',
  SUCCESS = 'success',
  WARN = 'warn',
}
